import script from "./walletIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./walletIndex.vue?vue&type=script&setup=true&lang=js"

import "./walletIndex.vue?vue&type=style&index=0&id=d2c443d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2c443d6"]])

export default __exports__